export const formatCurrency = (amount, locale = 'en-US') => {
  const value = parseFloat(amount) || 0;

  return value.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};
